import { render, staticRenderFns } from "./BracketHeaderRound.vue?vue&type=template&id=60bf3bf3&"
import script from "./BracketHeaderRound.vue?vue&type=script&lang=js&"
export * from "./BracketHeaderRound.vue?vue&type=script&lang=js&"
import style0 from "./BracketHeaderRound.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports